import { useEffect, useRef } from "react";
import { BehaviorSubject } from "rxjs";

export const useToObservable = <T>(state: T) => {
  const behaviorSubjectRef = useRef(new BehaviorSubject(state));
  useEffect(() => {
    behaviorSubjectRef.current.next(state);
  }, [state]);
  return behaviorSubjectRef.current.asObservable();
};
